import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';
import StudyDenBear from '../assets/images/branding/Studyden_Bear_Only.svg';

// Visible exactly while mounted. Its owner decides lifetime from real readiness
// state; there is no minimum display time that could outlive or restart loading.
const LoadingScreen = () => {
  const [messageIndex, setMessageIndex] = useState(0);

  const loadingMessages = [
    'Preparing your StudyDen...',
    'Getting everything ready...',
    'Loading your learning space...',
    'Almost ready...'
  ];

  // Handle message rotation
  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % loadingMessages.length);
    }, 800);

    return () => clearInterval(interval);
  }, [loadingMessages.length]);

  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <div className="loading-content">
        <div className="loading-brand-group">
          <div className="loading-logo-frame">
            <img src={StudyDenBear} alt="StudyDen" className="loading-logo-image" />
          </div>
        </div>

        <div className="loading-state-group">
          <p className="loading-title">Loading StudyDen</p>
          <p className="loading-tagline">Learn. Assess. Progress.</p>

          <div className="loading-track" aria-hidden="true">
            <span />
          </div>

          <p className="loading-message loading-visually-hidden">
            {loadingMessages[messageIndex]}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
